import React, { Fragment } from "react";
import OwlCarousel from "react-owl-carousel";

const ReviewSliderVideoSecond = () => {
  return (
    <Fragment>
      <section className="review_client_sec review_client_video_sec review_client_video_short mb-170">
        <div className="container">
          <OwlCarousel
            className="rs-carousel owl-carousel review_client_carousel"
            loop={true}
            margin={10}
            nav={true}
            items={7}
            autoplay={true}
            autoplayHoverPause={true}
            video={true}
            responsive={{
              1: {
                items: 1,
              },

              768: {
                items: 2,
              },
              992: {
                items: 3,
              },
              1200: {
                items: 3,
              },
            }}
          >
 
            <div className="testimonial_cover cover_one">
              <div className="row w-100 m-0">
                <div className="col-12 col-sm-12 col-md-12">
                  <div className="testimonial_wrapper">
                    <iframe  
                      width="315"
                      height="560" 
                      src="https://www.youtube.com/embed/PducNzGmQrQ?" 
                      title="Dr. Nikki  review #digitalmarketing #review" 
                      frameborder="0" 
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                      allowfullscreen></iframe>
                  </div>
                </div>
              </div>
            </div>
            <div className="testimonial_cover cover_two">
              <div className="row w-100 m-0">
                <div className="col-12 col-sm-12 col-md-12">
                  <div className="testimonial_wrapper">
                    <iframe  
                      width="315"
                      height="560" 
                      src="https://www.youtube.com/embed/99_Rev2JBSY?rel=0" 
                      title="Jackie Marin  review #digitalmarketing #review" 
                      frameborder="0" 
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                      allowfullscreen></iframe>
                  </div>
                </div>
              </div>
            </div>
            <div className="testimonial_cover cover_three">
              <div className="row w-100 m-0">
                <div className="col-12 col-sm-12 col-md-12">
                  <div className="testimonial_wrapper">
                    <iframe  
                      width="315"
                      height="560" 
                      src="https://www.youtube.com/embed/hkSJ6pEUggY?rel=0" 
                      title="Mark Anthony  review #digitalmarketing #review" 
                      frameborder="0" 
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                      allowfullscreen></iframe>
                  </div>
                </div>
              </div>
            </div>
            <div className="testimonial_cover cover_four">
              <div className="row w-100 m-0">
                <div className="col-12 col-sm-12 col-md-12">
                  <div className="testimonial_wrapper">
                      <iframe width="315" height="560" src="https://www.youtube.com/embed/Ssqge56AYZo" title="Vero &amp; Judy  #clientes #reviews #review" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"  allowfullscreen></iframe>
                  </div>
                </div>
              </div>
            </div>
            <div className="testimonial_cover cover_five">
              <div className="row w-100 m-0">
                <div className="col-12 col-sm-12 col-md-12">
                  <div className="testimonial_wrapper">
        
                      <iframe width="315" height="560" src="https://www.youtube.com/embed/Ohr8AvxW76s" title="Tim Hoff  #clientes #reviews #review" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"  allowfullscreen></iframe>
                  </div>
                </div>
              </div>
            </div>
            <div className="testimonial_cover cover_six">
              <div className="row w-100 m-0">
                <div className="col-12 col-sm-12 col-md-12">
                  <div className="testimonial_wrapper">
                
                      <iframe width="315" height="560" src="https://www.youtube.com/embed/-LtOnC1DD0g" title="Henry Scott #clientes #reviews #review" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"  allowfullscreen></iframe>
                  </div>
                </div>
              </div>
            </div>
            
            
          
           
          </OwlCarousel>
          <div className="view_more_wrapper">
            <a
              href="https://www.youtube.com/@EZMarketing.Agency/shorts"
              target="_blank"
              rel="noopener noreferrer"
              className="view_more_link"
            >
              View More Reviews
            </a>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default ReviewSliderVideoSecond;
